import { Row, Col, Modal, Spin } from 'antd';
import React, { useState } from 'react';
import ZenChartsInput from '../../pages/InputCreater/ZenChartsInput';
import DynamicZenChart from '../../pages/DynamicZenChart';
import liracrypt from '../Liracrypt/liracrypt';
import { LoadingOutlined } from '@ant-design/icons';
import DTModal from '../3DModels/DTModal';

const DtWidget = ({
    data
}) => {
    // console.log(data, 'dataTest2')
    const [openModal, setOpenModal] = useState(false);
    const [modal, setModal] = useState({
        open: false,
        loading: false,
        data: null,
        typ: ''
    });

    const toggleModal = ({ open = false, data = undefined, loading = false, typ = '' }) => {
        setModal({ open, data, loading, typ });
    }
    const openPopup = ({ onClick = {}, record, api }) => {
        let _data = { ...onClick?.params,...data.searchParams };
        _data.objectId = data.objectId;
        if (onClick?.multiProps) {
            onClick.multiProps.forEach(x => {
                _data[x] = record[x]
            })
        }
        toggleModal({
            api: onClick?.api,
            open: true,
            loading: true,
            data: {
                ..._data
            }
        });
        setTimeout(() => {
            toggleModal({
                api,
                open: true,
                typ: 'dynamicZenChart',
                loading: false,
                data: {
                    ..._data
                }
            });
        }, 500);
    }
    const closePopup = () => {
        toggleModal({
            open: true,
            loading: false,
            data: null
        });
        setTimeout(() => {
            toggleModal({
                open: false,
                loading: false,
                data: null
            });
        }, 20);
    }

    return (
        <>
            {
                data ?
                    <Row>
                        <Col span={6}>
                            <Row className='dt-widget-wrapper'>
                                {
                                    data?.gaugeCharts.map((x, i) => (
                                        <ZenChartsInput
                                            divId={x.divId}
                                            chartData={x.chartData}
                                            colSpan={x.colSize}
                                            typ={x.typ}
                                            style={x.style}
                                        />
                                    ))
                                }
                            </Row>
                        </Col>
                        <Col span={14}>
                            <Row className='dt-widget-wrapper'>
                                {
                                    data?.widgets.map((x, i) => (
                                        <Col style={{ cursor: 'pointer' }} key={`dt-widget-${i}`} span={x.colSize} onClick={() => openPopup({
                                            onClick: x.onClick,
                                            open: true,
                                            record: x
                                        })}>
                                            <Row style={x.style}>
                                                {
                                                    x.data.map((child, childIndex) => (
                                                        <Col span={child.colSize} key={`widget-child-${childIndex}`}>
                                                            {
                                                                child.typ === 'text' ?
                                                                    <div>
                                                                        {
                                                                            child.text.map((txt, indx) => (
                                                                                <p style={txt.style} key={`widget-txt-${indx}`}>{txt.text}</p>
                                                                            ))
                                                                        }
                                                                    </div> :
                                                                    <div className='dt-icon-wrapper'>
                                                                        <img height={50} width={50} src={require(`../../assets/static/${child.img}`)} />
                                                                    </div>
                                                            }
                                                        </Col>
                                                    ))
                                                }
                                            </Row>
                                        </Col>
                                    ))
                                }
                            </Row>
                        </Col>
                        <Col span={4}>
                            <Row className='dt-widget-wrapper'>
                                <Col span={24}>
                                    <div className='dt-icon-wrapper' style={{ justifyContent: 'center' }}>
                                        {
                                            data.trafficLight === 'g' ?
                                                <img style={{ height: '210px', width: 'auto' }} src={require(`../../assets/static/greenTraffic.png`)} /> :
                                                data.trafficLight === 'r' ?
                                                    <img style={{ height: '210px', width: 'auto' }} src={require(`../../assets/static/redTraffic.png`)} /> :
                                                    data.trafficLight === 'y' ?
                                                        <img style={{ height: '210px', width: 'auto' }} src={require(`../../assets/static/yellowTraffic.png`)} /> :
                                                        <img style={{ height: '210px', width: 'auto' }} src={require(`../../assets/static/redTraffic.png`)} />
                                        }
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={24}>
                            <Row className='dt-widget-wrapper'>
                                {
                                    data?.blueBlocks.map((x, i) => (
                                        <Col key={`dt-widget-${i}`} span={x.colSize} onClick={() => openPopup({
                                            open: true,
                                            record: x,
                                            onClick: x.onClick
                                        })} style={{ cursor: 'pointer' }}>
                                            <Row style={x.style}>
                                                {
                                                    x.data.map((child, childIndex) => (
                                                        <Col span={child.colSize} key={`widget-child-${childIndex}`}>
                                                            {
                                                                child.typ === 'text' ?
                                                                    <div>
                                                                        {
                                                                            child.text.map((txt, indx) => (
                                                                                <p style={txt.style} key={`widget-txt-${indx}`}>{txt.text}</p>
                                                                            ))
                                                                        }
                                                                    </div> :
                                                                    <div className='dt-icon-wrapper'>
                                                                        <img height={50} width={50} src={require(`../../assets/static/${child.img}`)} />
                                                                    </div>
                                                            }
                                                        </Col>
                                                    ))
                                                }
                                            </Row>
                                        </Col>
                                    ))
                                }
                            </Row>
                        </Col>
                        {
                            modal.open && (
                                <DTModal modal={modal} toggleModal={toggleModal} />
                            )
                        }

                        {/* <Modal width={"65%"} title="Part Details" className='digital-twin-modal' onCancel={closePopup} okButtonProps={{ hidden: true }} cancelButtonProps={{ hidden: true }} open={modal.open}>
                            {
                                modal.loading ?
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <Spin indicator={<LoadingOutlined spin style={{ fontSize: 70, color: '#ffffff' }} />} />
                                    </div> :
                                    modal.data && (
                                        <DynamicZenChart urlData={{ ...modal.data }} api={modal.api || '/dt'} />
                                    )
                            }
                        </Modal> */}
                    </Row> : <></>
            }

        </>
    )
};


export default DtWidget;